import { put, takeLatest } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import { Notify } from '@flexisaf/flexibull2';
import { TOP_RIGHT, SUCCESS } from 'utils/constants';
import { addGroupItemSuccess, addGroupItemFailure } from '../actions';
import GroupActionTypes from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';


const { API_BASE_URL } = urls || {};

function* addGroupItem({ payload }) {
  const url = `${API_BASE_URL}/application-group-items`;

  const response = yield request({
    method: 'post',
    data: payload.item,
    url,
  });
  if (response.success) {
    yield put(addGroupItemSuccess(response.raw));
    payload.cb();
    Notify('Group Item Created Successfully!', {
      position: TOP_RIGHT,
      status: SUCCESS,
    });
  } else {
    yield put(
      addGroupItemFailure(
        'An error occured. Please reload the page to try again.'
      )
    );

    const errorMesssage = response.statusCode === 409 ? 'Group item already exists' : response.message;
    networkErrorHandler(response?.statusCode, errorMesssage);
  }
}

export function* onAddGroupItem() {
  yield takeLatest(GroupActionTypes.ADD_GROUP_ITEM, addGroupItem);
}
